//for IMPORTANT: the functions: removeChild(), selected() is called in the file main.js
//for phone mask
var inputTel, themePath, iti,
    errorMap = {
        0 : {
            'en': 'invalid number',
            'ru': 'некорректный номер'
        },
        1 : {
            'en': 'invalid country code',
            'ru': 'неверный код страны'
        },
        2 : {
            'en': 'the number is too short',
            'ru': 'слишком короткий номер'
        },
        3 : {
            'en': 'the number is too long',
            'ru': 'слишком длинный номер'
        },
        4 : {
            'en': 'invalid number',
            'ru': 'некорректный номер'
        },
    };
function initTelInput() {
    if(!document.getElementById("phone")) return;
    if (themePath == undefined) themePath = '';
    inputTel = document.getElementById("phone");
    var formGroupTel = inputTel.closest('.form__group');
    iti = window.intlTelInput(inputTel, {
        initialCountry: "auto",
        geoIpLookup: function(callback) {
            $.get("//ipinfo.io", function() {}, "jsonp").always(function(resp) {
                var countryCode = (resp && resp.country) ? resp.country : "";
                callback(countryCode);
            });
        },
        separateDialCode: true,
        utilsScript: themePath + "/templates/arabica_v2/assets/js/components/intltelinput/utils.js",
    });
    if(iti) formGroupTel.classList.add('upLabel');
}
//for validation form
var lang = document.documentElement.getAttribute('lang'),
    formLang = lang == '' || lang == undefined || lang != 'ru' ? 'en' : lang,
    ageLimit = 18,
    validateNecessarily = [],
    formRegister = ['formRegister'],
    formAuth = ['formLogin'],
    formForgot = ['formForgotPassword'],
    formProfile = ['profile_form','profile_form-personal','profile_form-questionnaire','settings-form'],
    formId = ['search_form'],
    notActionForm = [],
    notClearForm = ['profile_form','profile_form-personal','profile_form-questionnaire'],
    notModalForm = [],
    fieldEmail = ['email','dialxs[email]'],
    fieldPass = ['pass','repass','newpass','renewpass'],
    fieldPassRepeat = {
        'settings-form' : ['pass','repass'],
        'formRePass' : ['newpass','renewpass'],
    }
    fieldOnlyText = ['comment'],
    fieldNoNumber = ['fname','sname'],
    fieldOnlyNumber = ['id','search_id','id_lady','filterUserID','filter_id_user'],
    fieldId = ['id','search_id','id_lady','filterUserID','filter_id_user'],
    fieldBirthday = ['b_day','b_month','b_year'],
    fieldReg = {
        onlyText: {
            'pattern': /(^(www\.|http:|https:))|([^\s@]+@[^\s@\s.])/,
            'fieldTooltip':{
                'en': 'field cannot contain emails and links',
                'ru': 'поле не может содержать адреса электронной почты и ссылки'}
        },
        noNumber: {
            'pattern': /\D/,
            'fieldTooltip':{
                'en': 'field cannot contain numbers',
                'ru': 'поле не может содержать цифры'}
        },
        onlyNumber: {
            'pattern': /\d/,
            'fieldTooltip':{
                'en':'the field can contain only numbers',
                'ru':'поле может содержать только цифры'}
        },
        birthday: {
            'pattern': {
                'day': /^(1|2|3)\d{0,}$|\d{1,}$/,
                'year': /^(?:19|20)\d{0,}$/,
            },
            'fieldTooltip':{
                0 : {
                    'en':'fill in the "birthday" fields correctly',
                    'ru':'заполните корректно поля "день рождения"'
                },
                1 : {
                    'en':'fill in the "year" field correctly',
                    'ru':'заполните корректно поле "год"'
                },
                2 : {
                    'en':'fill in the field "year" in the format "YYYY"',
                    'ru':'заполните поле "год" в формате "ГГГГ"'
                },
                3 : {
                    'en':'fill in the "day" field correctly',
                    'ru':'заполните корректно поле "день"'
                },
                4 : {
                    'en':'fill in the field "day" in format "DD"',
                    'ru':'заполните поле "день" в формате "ДД"'
                },
                5 : {
                    'en': 'enter valid date to pass '+ ageLimit +' years age limitation',
                    'ru': 'введите правильную дату, чтобы пройти ограничение возраста '+ ageLimit +' лет'
                },
            }
        },
        email: {
            'pattern': /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i,
            'fieldTooltip':{
                'en':'enter your valid email address',
                'ru':'введите правильный e-mail'}
        },
        pass: {
            'pattern': /.{6,}/,
            'fieldTooltip':{
                'en':'password must be at least 6 characters long',
                'ru':'пароль должен быть не менее 6 символов'},
            'fieldTooltipCorrectly':{
                'en':'passwords didn\'t match, try again',
                'ru':'пароли не совпадают, повторите попытку'}
        },
        heightUser: {
            'pattern': /^\d{2,3}$/i,
            'fieldTooltip':{
                'en':'indicate your height in in.(sm.)',
                'ru':'укажите свой рост в дюймах(см.)'}
        },
        weightUser: {
            'pattern': /^\d{2,3}$/i,'fieldTooltip':{
                'en':'indicate your weight in lbs.(kg.)',
                'ru':'укажите свой вес в фунтах(кг.)'}
        },
    },
    fieldTooltipText = {
        empty: {
            'en':'fill in the field',
            'ru':'заполните поле'
        },
        check: {
            'en':'check the box',
            'ru':'поставьте галочку'
        },
        captcha: {
            'en':'fill in CAPTCHA field',
            'ru':'заполните поле CAPTCHA'},
        file: {
            'en':'field "Choose file" not completed in a proper',
            'ru':'поле "Выбрать файл" не заполнено должным образом'},
        correctly:{
            'en':'fill in the field correctly',
            'ru':'заполните корректно поле'},
        phone:{
            'en':'indicate phone number',
            'ru':'укажите номер телефона'},
    },
    fieldTooltip = fieldTooltipText['empty'][formLang],
    textPopUp = {
        all : {
            'successfully': {
                'en':'Your message has been successfully sent.',
                'ru': 'Ваше сообщение успешно отправлено.'
            },
            'problem':{
                'en': 'Sorry, there are problems sending the message.',
                'ru': 'Извините, при отправке сообщения возникли проблемы.'
            }
        },
        register : {
            'successfully': {
                'en': 'You have successfully registered.',
                'ru': 'Вы успешно зарегистрировались.'
            },
            'problem':{
                'en': 'Sorry, there are problems registering.',
                'ru': 'Извините, при регистрации возникли проблемы.'
            }
        },
        auth : {
            'successfully': {
                'en': 'You have successfully logged in.',
                'ru': 'Вы успешно авторизировались.'
            },
            'problem':{
                'en': 'Sorry, there are problems with authorization.',
                'ru': 'Извините, при авторизации возникли проблемы.'
            }
        },
        forgot : {
            'successfully': {
                'en': 'An email will be sent to your email address that includes a password reset link.',
                'ru': 'На ваш электронный адрес будет отправлено письмо со ссылкой для восстановления пароля.'
            },
            'problem':{
                'en': 'Sorry, there are problems recovering your password.',
                'ru': 'Извините, при восстановлении пароля возникли проблемы.'
            }
        },
        personal : {
            'successfully': {
                'en': 'Your data has been successfully saved.',
                'ru': 'Ваши данные были успешно сохранены.'
            },
            'problem':{
                'en': 'Sorry, there was a problem saving your data.',
                'ru': 'Извините, при сохранении данных возникли проблемы.'
            }
        },
    },
    focusField = ['loginfields','to'],
    fieldValid = [], passConfirm = [];

function Validator(el,e) {
    e.preventDefault(); e.stopPropagation();
    var $FORM = el;
    var validatorEl = $FORM.getAttribute('id');
    var formType = selected(formRegister, validatorEl) ? 'register' : (selected(formAuth, validatorEl) ? 'auth' : (selected(formForgot, validatorEl) ? 'forgot' : (selected(formProfile, validatorEl) ? 'personal' : 'all')));
    var successfullyMessage = textPopUp[formType]['successfully'][formLang];
    var problemMessage = textPopUp[formType]['problem'][formLang];
    var validatorInit = function () {
        var validate = {
            validField: function () {
                var elements = $FORM.elements,
                    captcha = $FORM.querySelector('.captcha'),
                    validReturn = false;
                fieldValid.length = 0;
                passConfirm.length = 0;
                for (var i = 0; i < elements.length; i++) {
                    if (elements.item(i).classList.contains('required')) {
                        Required.requiredField(elements.item(i));
                    } else if (elements.item(i).classList.contains('text-input') || elements.item(i).classList.contains('textarea') || elements.item(i).classList.contains('select')) {
                        if(selected(validateNecessarily, validatorEl)) Required.validValidate(elements.item(i));
                    }
                }
                if (captcha && captcha.classList.contains('required')) Required.requiredField(captcha);
                !selected(fieldValid, false) ? validReturn = true : validReturn = false;
                return validReturn;
            },
            serialize: function () {
                var field, l, s = [];
                if (typeof $FORM == 'object' && $FORM.nodeName == "FORM") {
                    var len = $FORM.elements.length;
                    for (var i = 0; i < len; i++) {
                        field = $FORM.elements[i];
                        if (field.name && !field.disabled && field.type != 'button' && field.type != 'reset' && field.type != 'submit' && field.type != 'hidden') {
                            if (field.type == 'select-multiple') {
                                l = $FORM.elements[i].options.length;
                                for (var j = 0; j < l; j++) {
                                    if (field.options[j].selected) {
                                        s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[j].value);
                                    }
                                }
                            } else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
                                s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value);
                            }
                        }
                    }
                }
                return s.join('&').replace(/%20/g, '+');
            },
            submitForm: function () {
                //console.log(this.serialize());
                $.ajax({
                    type: $FORM.getAttribute('method'),
                    url: $FORM.getAttribute('action'),
                    data: this.serialize()
                }).done(function (data, textStatus, jqXHR) {
                    if (!selected(notModalForm, validatorEl)) modal.render(successfullyMessage);
                    setTimeout(function () {
                        if (!selected(notClearForm, validatorEl)) clearField($FORM);
                        modal.destroy();
                    }, 2000);
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    if (!selected(notModalForm, validatorEl)) swal({ text: problemMessage });
                    modal.render(problemMessage);
                    setTimeout(function () {
                        validate.resetCaptca();
                    }, 2000);
                });
            },
            submitFormAction: function (form) {
                var submitFormFunction = Object.getPrototypeOf(form).submit;
                submitFormFunction.call(form);
            },
        }
        if (validate.validField()){
            if(localStorage.getItem('rbdForm')) localStorage.removeItem('rbdForm');
            if ($FORM.hasAttribute('payment-count')) {
                var paymentCount = parseInt($FORM.getAttribute('payment-count')),
                    paymentPrice = parseInt($FORM.querySelector('[payment-price]').getAttribute('payment-price'));
                if(paymentCount < paymentPrice){
                    //the function is called in the file modal.js
                    paymentModal($FORM);
                }else{
                    if($FORM.getAttribute('action') === '/gifts/'){
                        //the function is called in the file modal.js
                        viewSentGifts($FORM);
                    }else{
                        selected(notActionForm, validatorEl) ? validate.submitForm() : validate.submitFormAction($FORM);
                    }
                }
            }else{
                selected(notActionForm, validatorEl) ? validate.submitForm() : validate.submitFormAction($FORM);
            }
        }else{
            return false;
        }
    };
    validatorInit($FORM);
}
function addValidator(e){
    e.preventDefault();
}
function checkCall(id) {
    return new Promise(function(resolve, reject){
        if(!id) return reject(new Error('emptyID'));
        $.ajax({
            type: "POST",
            url: "/ajax.php?com=check_lady",
            data: {"id": id},
            cache: false,
            async: false,
            success: function (response) {
                if (response) {
                    response = $.parseJSON(response);
                    if (response.error !== "ok") {
                        return reject(new Error('InvalidID'),response);
                    }
                    resolve(response);
                }
            },
            fail : function (e, textStatus){
                reject(new Error(textStatus));
            }
        });
    });
}
//for validation required field
var fieldEl, fieldVal, idForm;
var Required = {
    requiredField: function(e){
        fieldEl = e.target !== undefined ? e.target : e;
        idForm = fieldEl.closest('form') ? fieldEl.closest('form').getAttribute('id') : '';
        var fieldName =  fieldEl.classList.contains('captcha') ? 'captcha' : fieldEl.getAttribute('name');
        var initValidate = function(fieldEl,fieldName,fieldVal) {
            if(!fieldVal){
                if(fieldEl.type === 'checkbox' || fieldEl.type === 'radio'){
                    Required.invalidValidate(fieldEl,fieldTooltipText['check'][formLang]);
                }else if(fieldEl.type === 'file'){
                    Required.uploadValidate(fieldEl,fieldVal);
                }else if(fieldEl.type === 'number'){
                    Required.onlyNumberValidate(fieldName,fieldVal);
                }else if(fieldName === 'comment'){
                    Required.validValidate(fieldEl);
                }else{
                    Required.invalidValidate(fieldEl,fieldTooltipText['empty'][formLang]);
                }
            } else if(selected(fieldOnlyText, fieldName)){
                Required.onlyTextValidate(fieldName,fieldVal);
            } else if(selected(fieldNoNumber, fieldName)){
                Required.noNumberValidate(fieldName,fieldVal);
            } else if(selected(fieldOnlyNumber, fieldName)){
                Required.onlyNumberValidate(fieldName,fieldVal);
            } else if(selected(fieldPass, fieldName)){
                Required.passwordValidate(fieldName,fieldVal);
            } else if(selected(fieldEmail, fieldName)){
                Required.emailValidate(fieldName,fieldVal);
            } else if(selected(fieldBirthday, fieldName)){
                Required.birthdateValidate(fieldName,fieldVal);
            } else if(selected(Object.keys(fieldReg), fieldName)){
                !fieldVal.match(fieldReg[fieldName]['pattern']) ? Required.invalidValidate(fieldEl,fieldReg[fieldName]['fieldTooltip'][formLang]) : Required.lengthValidate(fieldName, fieldVal);
            } else if(fieldName === 'phone_number'){
                Required.telValidate(fieldName,fieldVal);
            }else if(fieldEl.type == 'file'){
                Required.uploadValidate(fieldEl,fieldVal);
            }else if(fieldName === 'captcha'){
                Required.captchaValidate(fieldEl);
            }else{
                Required.lengthValidate(fieldName);
            }
        };
        if(fieldEl.type == 'checkbox' || fieldEl.type == 'radio'){
            fieldEl.checked ? fieldVal = 'checked' : fieldVal = '';
        } else if(fieldName === 'captcha'){
            fieldVal = Required.captchaVal(fieldEl);
        } else if(fieldEl.type == 'file'){
            if(e.target !== undefined){
                fieldVal = fieldEl.files.length > 0 ? 'file' : '';
            }else{
                fieldVal = fieldEl.value;
            }
        } else {
            fieldVal = fieldEl.value.trim();
        }
        !fieldVal.match('\<(\/?[^>]+)>|--|\/\/') ? initValidate(fieldEl,fieldName,fieldVal) : Required.invalidValidate(fieldEl,fieldTooltipText['correctly'][formLang]);
        if(selected(fieldId, fieldName) && selected(formId, idForm)){
            var form = document.getElementById(idForm);
            if(selected(fieldValid, false)){
                if(!form.hasAttribute('data-listener')){
                    form.setAttribute('data-listener','validator');
                    form.addEventListener('submit', addValidator, false);
                }
            }
            if(selected(fieldValid, true)){
                form.removeAttribute('data-listener');
                form.removeEventListener('submit', addValidator, false);
            }
        }
    },
    lengthValidate: function(fieldName) {
        var fieldEl = document.querySelector('[name="'+ fieldName +'"]');
        var lengthVal = fieldEl.value.trim().length,
            lengthMin = fieldEl.getAttribute('minlength'),
            lengthMax = fieldEl.getAttribute('maxlength'),
            lengthText = {
                'en' : selected(fieldNoNumber, fieldName) ? ' letters' : (selected(fieldOnlyNumber, fieldName) ? ' numbers' : ' characters'),
                'ru' : selected(fieldNoNumber, fieldName) ? ' букв' : (selected(fieldOnlyNumber, fieldName) ? ' цифр' : ' символов')
            },
            lengthTooltip = {
                strong: {
                    'en' : 'enter '+ (lengthMin || lengthMax) + lengthText[formLang],
                    'ru' : 'введите '+ (lengthMin || lengthMax) + lengthText[formLang]
                },
                range: {
                    'en' : 'enter '+ lengthMin +' to '+ lengthMax + lengthText[formLang],
                    'ru' : 'введите от '+ lengthMin +' до '+ lengthMax + lengthText[formLang]
                },
                min: {
                    'en' : 'enter more than '+ lengthMin + lengthText[formLang],
                    'ru' : 'введите более '+ lengthMin + lengthText[formLang]
                },
                max: {
                    'en' : 'enter less than '+ lengthMax + lengthText[formLang],
                    'ru' : 'введите меньше '+ lengthMax + lengthText[formLang]
                },
            };
        if(lengthMin && lengthMax){
            if(lengthMin == lengthMax){
                if(lengthMin == lengthVal || lengthMax ==  lengthVal){
                    if(selected(fieldId, fieldName)){
                        var $this = this,
                            id = parseInt(fieldEl.value);
                        checkCall(id).then(function (response){
                            $this.validValidate(fieldEl);
                            if(idForm === 'gift_form'){
                                var modal = document.getElementById('gift_form').closest('.modal__content');
                                $.ajax({
                                    type: "POST",
                                    url: "/ajax_search.php?com=search",
                                    data: {"search": id},
                                    cache: false,
                                    success: function(data){
                                        if(data){
                                            document.getElementById('user_id').value = id;
                                            document.getElementById('search_result').innerHTML = data;
                                            minHW(modal);
                                        }
                                    }
                                });
                            }
                        })['catch'](function(){
                            $this.invalidValidate(fieldEl,fieldTooltipText['correctly'][formLang] + ' ID number');
                        });
                    } else{
                        this.validValidate(fieldEl);
                    }
                } else {
                    this.invalidValidate(fieldEl,lengthTooltip['strong'][formLang]);
                }
            } else{
                lengthMin <= lengthVal && lengthVal <= lengthMax ? this.validValidate(fieldEl) : this.invalidValidate(fieldEl,lengthTooltip['range'][formLang]);
            }
        } else if(lengthMin && !lengthMax){
            lengthMin <= lengthVal ? this.validValidate(fieldEl) : this.invalidValidate(fieldEl,lengthTooltip['min'][formLang]);
        } else if(!lengthMin && lengthMax){
            lengthMax >= lengthVal ? this.validValidate(fieldEl) : this.invalidValidate(fieldEl,lengthTooltip['max'][formLang]);
        } else {
            Required.validValidate(fieldEl);
        }
    },
    birthdateValidate: function(fieldName,fieldVal) {
        var dataYear = document.querySelector('[name=b_year]'),
            dataMonth = document.querySelector('[name=b_month]'),
            dataDay = document.querySelector('[name=b_day]'),
            dataDate = [dataYear.value, dataMonth.value, dataDay.value],
            resDate = parseInt(isAge());
        resDate == 6 ? Required.validValidate(fieldEl) : Required.invalidValidate(fieldEl,fieldReg['birthday']['fieldTooltip'][resDate][formLang]);
        [0,1,2,5].includes(resDate) ? invalidDate('b_year') : validDate('b_year');
        [0,3,4,5].includes(resDate) ? invalidDate('b_day') : validDate('b_day');
        resDate == 5 ? invalidDate('b_month') : validDate('b_month');
        function isAge(){
            var d = new Date(dataDate[0], dataDate[1]-1, dataDate[2]),
                dateAgeLimit = new Date(d.getFullYear() + ageLimit, d.getMonth(), d.getDate()),
                flagYear = !dataDate[0].match(fieldReg['birthday']['pattern']['year']),
                flagDay = !dataDate[2].match(fieldReg['birthday']['pattern']['day']);
            if ((flagYear && flagDay) || (dataDate[0].length < 4) || (flagYear) || (dataDate[0].length < 4 && flagDay)){
                return 0;
            }else if(flagYear){
                return 1;
            }else if(dataDate[0].length < 4){
                return 2;
            }else if(flagDay || (dataDate[2] > 31) || (dataDate[2] > 30 && [4,6,9,11].includes(parseInt(dataDate[1]))) || (dataDate[2] > 29 && dataDate[1] == 2)){
                return 3;
            }
            return dateAgeLimit > new Date() ? 5 : 6;
        }
        function invalidDate(fieldName) {
            var dataGroup = document.querySelector("[name="+fieldName+"]").parentNode;
            dataGroup.classList.add('date__invalid');
        }
        function validDate(fieldName) {
            var dataGroup = document.querySelector("[name="+fieldName+"]").parentNode;
            dataGroup.classList.remove('date__invalid');
        }
    },
    emailValidate: function (fieldName,fieldVal) {
        if(!fieldVal.match(fieldReg['email']['pattern'])){
            Required.invalidValidate(fieldEl,fieldReg['email']['fieldTooltip'][formLang]);
        }else{
            Required.lengthValidate(fieldName);
        }
    },
    passwordValidate: function(fieldName,fieldVal) {
        if(!fieldVal.match(fieldReg['pass']['pattern'])){
            Required.invalidValidate(fieldEl,fieldReg['pass']['fieldTooltip'][formLang])
        } else if(fieldPassRepeat[idForm] !== undefined && selected(fieldPassRepeat[idForm], fieldName)){
            if(fieldName == fieldPassRepeat[idForm][0]){
                passConfirm[0] = fieldVal;
                Required.validValidate(fieldEl);
            }else{
                selected(passConfirm, fieldVal) ? Required.validValidate(fieldEl) : Required.invalidValidate(fieldEl,fieldReg['pass']['fieldTooltipCorrectly'][formLang]);
            }
        } else {
            Required.validValidate(fieldEl);
        }
    },
    onlyTextValidate: function(fieldName,fieldVal) {
        fieldVal.match(fieldReg['onlyText']['pattern']) ? Required.invalidValidate(fieldEl,fieldReg['onlyText']['fieldTooltip'][formLang]) : Required.lengthValidate(fieldName);
    },
    noNumberValidate: function(fieldName,fieldVal) {
        !fieldVal.match(fieldReg['noNumber']['pattern']) ? Required.invalidValidate(fieldEl,fieldReg['noNumber']['fieldTooltip'][formLang]) : Required.lengthValidate(fieldName);
    },
    onlyNumberValidate: function(fieldName,fieldVal) {
        if(fieldVal){
            !fieldVal.match(fieldReg['onlyNumber']['pattern']) ? Required.invalidValidate(fieldEl,fieldReg['onlyNumber']['fieldTooltip'][formLang]) : Required.lengthValidate(fieldName);
        }else{
            if(fieldEl.type == 'text'){
                Required.invalidValidate(fieldEl,fieldTooltipText['empty'][formLang]);
            }else if(fieldEl.type == 'number'){
                Required.invalidValidate(fieldEl,fieldReg['onlyNumber']['fieldTooltip'][formLang]);
            }
        }
    },
    telValidate: function(fieldName,fieldVal) {
        fieldVal ? (iti.isValidNumber() ? (Required.validValidate(fieldEl), inputTel.value = iti.getNumber()) : Required.invalidValidate(fieldEl,errorMap[iti.getValidationError()][formLang])) : Required.invalidValidate(fieldEl,fieldTooltipText['phone'][formLang]);
     },
    uploadValidate: function(fieldEl,fieldVal) {
        var formGroup = fieldEl.closest('.form__group-file');
        fieldEl.getAttribute('data-error') ? Required.invalidValidate(fieldEl,fieldTooltipText['file'][formLang]) : (fieldVal ? Required.validValidate(fieldEl) : formGroup.classList.remove('form__group-valid'));
    },
    captchaVal: function(fieldEl) {
        var captchaEl = document.querySelectorAll('.captcha');
        for (var i = 0; i < captchaEl.length; i++){
            if(fieldEl.getAttribute('id') === captchaEl[i].getAttribute('id')){
                return grecaptcha.enterprise.getResponse(i);
            }
        }
    },
    captchaValidate: function(fieldEl) {
        Required.captchaVal(fieldEl) === 0 ? Required.invalidValidate(fieldEl,fieldTooltipText['captcha'][formLang]) : Required.validValidate(fieldEl);
    },
    addTooltip: function(fieldEl,fieldTooltip,state){
        var formGroup = fieldEl.closest('.form__group');
        var fieldFileTooltip = fieldEl.getAttribute('text-error') ? fieldEl.getAttribute('text-error') : fieldTooltip;
        var createTooltip = function (fieldTooltip,state) {
            var tooltip = document.createElement('div');
            tooltip.classList.add('form__tooltip');
            if(!state){
                tooltip.className = 'form__tooltip';
                formGroup.classList.remove('form__group-valid');
                formGroup.classList.add('form__group-invalid');
            }else{
                tooltip.className = 'form__tooltip';
                formGroup.classList.remove('form__group-invalid');
                formGroup.classList.add('form__group-valid');
            }
            tooltip.innerHTML = '<span>'+ fieldFileTooltip +'</span>';
            return tooltip;
        };
        //if(formGroup.lastElementChild.classList.contains('form__tooltip')) removeChild(formGroup.lastElementChild);
        $(formGroup).find('> .form__tooltip').remove();
        if(formGroup) formGroup.appendChild(createTooltip(fieldTooltip,state));
        if(!idForm){
            return;
        }else{
            if(document.getElementById(idForm).closest('.form-header.popup')){
                minHW(document.getElementById(idForm));
            }
        }
    },
    invalidValidate: function(fieldEl,fieldTooltip) {
        this.addTooltip(fieldEl,fieldTooltip,false);
        fieldValid.push(false);
    },
    validValidate: function(fieldEl) {
        this.addTooltip(fieldEl,'field confirmed', true);
        fieldValid.push(true);
    }
}
//for CLEAR FORM
function  clearField(form) {
    var validatorEl = form.getAttribute('id'),
        input = form.querySelectorAll('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"])'),
        textarea = form.querySelectorAll('textarea'),
        checkBox = form.querySelectorAll('[type=checkbox]'),
        checkRadio = form.querySelectorAll('[type=radio]'),
        formGroup = form.querySelectorAll('.form__group'),
        formTooltip = form.querySelectorAll('.form__tooltip'),
        resetCaptcha = function () {
            if(!document.querySelectorAll(".captcha").length) return;
            var fieldCaptcha = document.querySelectorAll(".captcha");
            for (var i = 0; i < fieldCaptcha.length; i++) grecaptcha.enterprise.reset(i);
        };
    for (var i = 0; i < formGroup.length; i++){
        formGroup[i].classList.remove('form__group-valid');
        formGroup[i].classList.remove('form__group-invalid');
        if (!selected(notClearForm, validatorEl)) formGroup[i].classList.remove('activate');
    }
    for (var i = 0; i < formTooltip.length; i++) removeChild(formTooltip[i]);
    if (!selected(notClearForm, validatorEl)) {
        if(input.length) for (var i = 0; i < input.length; i++) input[i].value = '';
        if(textarea.length) for (var i = 0; i < textarea.length; i++) textarea[i].value = '';
        if(checkBox.length) for (var i = 0; i < checkBox.length; i++){
            if(checkBox[i].classList.contains('required') || checkBox[i].hasAttribute('payment-price')) checkBox[i].checked = false;
            if(checkBox[i].hasAttribute('payment-price')) choiceGift(checkBox[i]);
        }
        if(checkRadio.length) for (var i = 0; i < checkRadio.length; i++){
            if(checkRadio[i].classList.contains('required') || checkRadio[i].hasAttribute('payment-price')) checkRadio[i].checked = false;
            if(checkRadio[i].hasAttribute('payment-price')) choiceGift(checkRadio[i]);
        }
        if(validatorEl === 'gift_form'){
            var searchResult = document.getElementById('search_result'),
                giftResult = document.getElementById('gift_result'),
                userId = document.getElementById('user_id'),
                viewId = document.getElementById('view_id'),
                presentId = document.getElementById('id_present'),
                textCounter = document.getElementById('textCounter');
            if(searchResult && userId && viewId && (parseInt(viewId.value) !== parseInt(userId.value))) searchResult.innerHTML = '';
            if(userId && viewId && (parseInt(viewId.value) !== parseInt(userId.value))) userId.value = 0;
            if(giftResult) giftResult.innerHTML = '';
            if(presentId) presentId.value = 0;
            if(textCounter) textCounter.innerText = '0';
            if(document.querySelectorAll('[payment-price]').length){
                var price = document.querySelectorAll('[payment-price]');
                for(var i = 0; i < price.length; i++){
                    price[i].checked = false;
                    price[i].removeAttribute('checked');
                    if(price[i].getAttribute('id') == 'gift_result_check') choiceGift(price[i]);
                }
            }
        }
        if(validatorEl === 'contactUs_form'){
            if(document.querySelectorAll('.file-input').length){
                var file = document.querySelectorAll('.file-input');
                for(var i = 0; i < price.length; i++) Form.formFileClear(file[i]);
            }
        }
        resetCaptcha();
    }
}
//for RESET FORM
function resetForm() {
    if(!document.querySelectorAll('[type="reset"]').length) return;
    var reset = document.querySelectorAll('[type="reset"]');
    for(var i = 0; i < reset.length; i++) reset[i].addEventListener('click', clearField(reset[i].closest('form')));
}
//for INPUT CHECKBOX and RADIO
function initCheck() {
    if (!document.querySelectorAll('input[class*="check"]').length) return;
    var inputCheck = document.querySelectorAll('input[class*="check"]');
    for(var i = 0; i < inputCheck.length; i++){
        var id = inputCheck[i].getAttribute('id');
        if (id == undefined || id == ''){
            inputCheck[i].setAttribute('id', 'check-' + (i + 1));
            if(inputCheck[i].labels.length) {
                for(var j = 0; j < inputCheck[i].labels.length; j++) inputCheck[i].labels[j].setAttribute('for', 'check-' + (i + 1));
            }else{
                inputCheck[i].parentElement.querySelector('label').setAttribute('for', 'check-' + (i + 1));
            }
        }
    }
}
//for PASSWORD TRIGGER
function initPassword(){
    if (!document.querySelectorAll('.password_icon').length) return;
    var passwordTrigger = document.querySelectorAll('.password_icon');
    var triggerPassword = function (e) {
        var el = e.target;
        var formGroup = el.parentNode;
        var input = formGroup.querySelector('input');
        var type = input.getAttribute('type') == "text" ? "password" : 'text';
        input.setAttribute('type', type);
        formGroup.classList.toggle('password-show');
    };
    for(var i = 0; i < passwordTrigger.length; i++){
        passwordTrigger[i].addEventListener('click', triggerPassword);
    }
}
//for SELECT PLUGIN
function addFocus(e) {
    this.closest('.form__group').classList.add('focus');
    if(this.classList.contains('required')) Required.requiredField(e);
}
function removeFocus(e) {
    this.closest('.form__group').classList.remove('focus');
    if(this.classList.contains('required')) Required.requiredField(e);
}
function modalSelect(){
    if(this.options.length == 1){
        parseInt(document.getElementById('search-country').value) === 0 ? modal.render('Country is not selected.') : modal.render('Unable to create list cities.');
    }
}
function initSelect(){
    if (!$('.select').length) return;
    $('.select').each(function () {
        var select = $(this),
            name = select.attr('name'),
            nameSeach = ['country','city'];
        if(selected(nameSeach, name)){
            if(name == 'city'){
                select.select2().on('select2:open', addFocus, modalSelect).on('select2:close', removeFocus);
            }else{
                select.select2().on('select2:open', addFocus).on('select2:close', removeFocus);
            }
        }else{
            select.select2({minimumResultsForSearch: -1}).on('select2:open', addFocus).on('select2:close', removeFocus);
        }
    });
}
//for VALIDATE FORM
function validateForm(){
    if(!document.querySelectorAll('form').length) return;
    var form = document.querySelectorAll('form');
    for(var i = 0; i < form.length; i++){
        //for LABEL STATE
        if(form[i].querySelectorAll('label').length){
            var label = form[i].querySelectorAll('label');
            var activeField = function (e) {
                var el = e.target !== undefined ? e.target : e;
                var event = e.target !== undefined ? e.type : '';
                var formGroup = e.target !== undefined ? el.closest('.form__group') : e.closest('.form__group');
                if(formGroup){
                    if(event === 'focus'){
                        formGroup.classList.add('focus');
                    }else if(event === 'blur'){
                        formGroup.classList.remove('focus');
                    }else if(event === 'keyup' || event === 'change'){
                        el.value ? formGroup.classList.add('activate') : formGroup.classList.remove('activate');
                    }else if(el.value){
                        formGroup.classList.add('activate');
                    }
                }
            };
            for(var j = 0; j < label.length; j++){
                var idField = label[j].getAttribute('for');
                var field = document.getElementById(idField);
                if(field){
                    if(selected(focusField, idField)){
                        field.focus();
                        field.closest('.form__group').classList.add('focus');
                    }
                    activeField(field);
                    field.addEventListener('focus', activeField);
                    field.addEventListener('blur', activeField);
                    field.addEventListener('keyup', activeField);
                    field.addEventListener('change', activeField);
                }
            }
        }
        //for VALIDATE FIELDS
        if(form[i].querySelectorAll('.required').length){
            var $fieldRequired = form[i].querySelectorAll('.required');
            for(var j = 0; j < $fieldRequired.length; j++){
                $fieldRequired[j].addEventListener('keyup', Required.requiredField);
                $fieldRequired[j].addEventListener('change', Required.requiredField);
            }
        }
    }
}
//for INIT FORMS
document.addEventListener("DOMContentLoaded", function() {
    initCheck(), initSelect(), initPassword(), initTelInput(), validateForm(), resetForm();
});
